import script from "./MapProfiles.vue?vue&type=script&lang=ts&setup=true"
export * from "./MapProfiles.vue?vue&type=script&lang=ts&setup=true"

import "./MapProfiles.vue?vue&type=style&index=0&id=3d425c27&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d425c27"]])

export default __exports__